<template>
  <div id="recent-containers-table" class="chemtracker-module">
    <label style="font-size: var(--font-size-200, 1.5rem)"
      >Chemical Inventory Recently Added</label
    >
    <b-table
      striped
      hover
      :sticky-column="true"
      :no-local-sorting="true"
      :no-sort-reset="true"
      show-empty
      :busy="isBusy"
      :fields="getFields"
      :items="updateInstitutionalChemicalContainers"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      ref="table"
      :class="{
        'table-pause-scroll': isBusy || chemContainers?.length < 1,
      }"
      current-page="1"
      data-test="recent-table"
      responsive
    >
      <template #table-busy>
        <RaftBusy busy-text="Loading..." />
      </template>
      <template #empty="scope">
        <div class="chemtracker-empty-text">
          <p>{{ emptyStateText }}</p>
        </div>
      </template>
      <template #cell(field_chemical_container_id)="data">
        <b-link
          :href="buildContainerUrl({ container: data.item })"
          target="_blank"
          >{{ data.item.field_chemical_container_id }}</b-link
        >
      </template>
      <template #cell(chemical_container_edit)="data">
        <b-link
          :href="buildContainerUrl({ container: data.item, edit: true })"
          target="_blank"
          >Edit</b-link
        >
      </template>
      <template #cell(og_audience[0].title)="data">
        <a
          v-if="data.item.og_audience[0]"
          :href="buildNodeUrl(data.item.og_audience[0].drupal_internal__nid)"
        >
          {{ data.item.og_audience[0].title }}</a
        >
      </template>
      <template #cell(field_chemical_space.title)="data">
        <a
          v-if="data.item.field_chemical_space"
          :href="
            buildNodeUrl(data.item.field_chemical_space.drupal_internal__nid)
          "
        >
          {{ data.item.field_chemical_space.title }}</a
        >
      </template>
      <template #cell(field_chemical_name_preferred)="data">
        <a
          v-if="data.item.field_chemical_name_preferred"
          :href="buildChemicalTypeUrl(data.item)"
          >{{ data.item.field_chemical_name_preferred }}</a
        >
      </template>
      <template
        #cell(field_chemical_container_owner.field_prof_display_name)="data"
      >
        <a
          v-if="data.item.field_chemical_container_owner"
          :href="buildUserUrl(data.item.field_chemical_container_owner)"
        >
          {{
            data.item.field_chemical_container_owner.field_prof_display_name
          }}</a
        >
      </template>
      <template #cell(field_chemical_note)="data">
        {{ formatters.formatNotes(data.item.field_chemical_note) }}
      </template>
    </b-table>
  </div>
</template>

<script>
import { useChemicalContainers } from "@/composables/useChemicalContainers";
import RaftBusy from "../RaftBusy.vue";

export default {
  name: "RecentContainers",
  setup(props) {
    const {
      state,
      table,
      getFields,
      chemContainers,
      updateInstitutionalChemicalContainers,
      updateInstitutionalChemicalContainersAsync,
      buildContainerUrl,
      buildChemicalTypeUrl,
      buildNodeUrl,
      buildUserUrl,
      formatters,
    } = useChemicalContainers(
      props.contextNid,
      Math.floor((Date.now().valueOf() - 6 * 1000 * 60 * 60) / 1000),
    );
    const { isBusy, sortBy, sortDesc, emptyStateText } = state.value;
    return {
      buildContainerUrl,
      isBusy,
      sortBy,
      sortDesc,
      table,
      emptyStateText,
      buildChemicalTypeUrl,
      buildNodeUrl,
      buildUserUrl,
      getFields,
      chemContainers,
      updateInstitutionalChemicalContainers,
      updateInstitutionalChemicalContainersAsync,
      formatters,
    };
  },
  async mounted() {
    this.updateInstitutionalChemicalContainersAsync();
  },
  props: {
    contextNid: {
      type: String,
      default: "",
    },
  },
  components: {
    RaftBusy,
  },
};
</script>

<style scoped>
#recent-containers-table {
  margin-top: 0.5rem;
}
</style>
